import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './NewDashboard.less';
import geoHierarchyLevels from '../../geoHierarchyLevels';
import LoadingStatus from '../LoadingStatus/LoadingStatus.jsx';
import { getActiveTab, TAB } from '../Navigation/Menu/menuConfig';
import PriceHistoryWidgetWithRentPrice from '../PriceHistory/Widget/PriceHistoryWidgetWithRentPrice';
import NewPriceCheckWidget from '../PriceCheck/Widget/NewPriceCheckWidget.tsx';
import {
  getAddress,
  getAddressStatus,
  getAddressTitleAndSubtitle,
  getDuplicateDistricts,
  getGeoHierarchy,
  getGeoHierarchyStatus,
  getGeoType,
  getHierarchyLevel,
  getPageViewId,
  getPricesForPriceHistoryWidget,
  getPriceHistoryStatus,
  getApartmentAndHousePrices,
  getRealEstateType,
  getSubHierarchyLinks,
  getSubHierarchyLinksStatus,
  getUserIntent,
} from '../../selectors/selectors.js';
import Header from '../Header/Header.jsx';
import NewAtlasTouchpointWrapper from '../AtlasTouchpointWrapper/NewAtlasTouchpointWrapper.jsx';
import titleExtractor from '../../utils/titleExtractor';
import NewSubHierarchyInfoWidget from '../SubHierarchyInfoWidget/NewSubHierarchyInfoWidget.jsx';
import realEstateTypes from '../../realEstateTypes';
import NewMyPropertyTeaser from '../HomeOwnerWorldTeaser/HomeOwnerWorldNewTeaser';
import NewBreadcrumb from '../Header/Breadcrumb/NewBreadcrumb';
import NewTitle from '../Header/Title/NewTitle';
import CampaignParametersDashboard from '../Utils/Touchpoint/CampaignParametersDashboard';
import GeoHierarchyDescription from '../Header/GeoHierarchyDescription';
import PriceInformation from '../PriceInformation/PriceInformation';
import IBWConversion from '../IBWConversion/IBWConversion';
import Faq from '../Faq/Faq';
import PriceTableWidget from '../PriceTable/PriceTableWidget';
import DashboardWidget from './DashboardWidget';
import { PROPERTY_BOOK_V2 } from "../../tracking/trackingNaming";
import NewNavigationHeader, { VIEW_TYPE_NEW_DASHBOARD } from "../Navigation/Header/NewNavigationHeader";
import { withLocation, withNavigate } from "../../utils/router";
import NoDataWidget from "../Utils/Widget/NoDataWidget/NoDataWidget";
import { ALIGN } from "../Utils/Widget/Title/NewWidgetTitle";
import { PRICE_OVERVIEW_PROMO_NEW_TO_HOMEOWNER_LANDINGPAGE_URL } from "../MyPropertyRelocation/urls";
import NewStaticMapWidget from "../StaticMapWidget/NewStaticMapWidget";

const shareOfVoiceWidgetGeoLevels = [
  geoHierarchyLevels.ADDRESS,
  geoHierarchyLevels.STREET,
  geoHierarchyLevels.DISTRICT,
  geoHierarchyLevels.CITY,
  geoHierarchyLevels.REGION,
];
const shareOfVoiceRealEstateTypes = [realEstateTypes.APARTMENT_BUY, realEstateTypes.HOUSE_BUY];

export class NewDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      stickyWidget: 'hidden',
      stickyBottomWidget: 'hidden',
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onWindowScroll);
    window.addEventListener('resize', this.onWindowScroll);
    this.onWindowScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onWindowScroll);
    window.removeEventListener('resize', this.onWindowScroll);
  }

  isTabVisible = (tabId) => getActiveTab(this.props.location.pathname) === tabId;

  onWindowScroll = () => {
    let stickyMode = false;
    let stickyBottomMode = 'visible';

    if (window.scrollY < 550) {
      stickyMode = 'hidden';
    } else if (window.scrollY > 330) {
      if (window.scrollY < document.body.offsetHeight - document.getElementById('footer').offsetHeight - 426 - 30) {
        stickyMode = true;
      } else {
        stickyMode = 'bottom';
      }
    }

    if (window.scrollY < 450) {
      stickyBottomMode = 'hidden';
    } else if (window.scrollY < 570) {
      stickyBottomMode = 'hiddenMobile';
    }

    this.setState({
      stickyWidget: stickyMode,
      stickyBottomWidget: stickyBottomMode,
    });
  };

  renderHeader() {
    return <Header />;
  }

  render() {
    const {
      priceHistoryStatus,
      addressStatus,
      geoHierarchyStatus,
      subHierarchyLinkStatus,
      subHierarchyLinks,
      hierarchyLevel,
      userIntent,
      geoHierarchy,
      address,
      addressTitle,
      realEstateType,
      duplicateDistricts,
      geoType,
      priceHistory
    } = this.props;

    const titleData = titleExtractor(hierarchyLevel, geoHierarchy, address, duplicateDistricts);

    const {
      apartmentAndHousePrices: { apartmentPrices, housePrices },
    } = this.props;

    return (
      <>
        <div className="grid grid-flex grid-align-stretch padding-bottom-l gutter-l">
          <div className={`${styles.headerContainerWithMyPropertyFeature} grid-item one-whole`}>
            {this.renderHeader()}
          </div>
        </div>
        <div className="grid grid-flex align-center">
          <div className={`grid-item lap-one-whole palm-one-whole ${styles.main}`}>
            <div className="grid grid-flex grid-fill-rows padding-bottom-xxl">
              <div className={`grid-item desk-one-half one-whole ${styles.contentColumn}`}>
                <div className="grid grid-flex">
                  <div className={`grid-item one-whole ${styles.newHeaderContainer}`}>
                    <NewBreadcrumb breadcrumbItems={geoHierarchy} hierarchyLevel={hierarchyLevel} />
                    <NewTitle userIntent={userIntent} text={titleData.fullTitle} />
                    <LoadingStatus status={[priceHistoryStatus]} renderLoader={() => null}>
                      {() => <IBWConversion />}
                    </LoadingStatus>
                    <NewNavigationHeader viewType={VIEW_TYPE_NEW_DASHBOARD} groupName={'NewDashboard'} />
                    <GeoHierarchyDescription locationName={titleData.title} />
                  </div>

                  {!priceHistory ?
                    <NoDataWidget text={`Immobilienpreisentwicklung in ${addressTitle} für Wohnungen und Häuser`} align={ALIGN.left} /> :
                    <PriceHistoryWidgetWithRentPrice
                    address={addressTitle}
                    realEstateType={realEstateType}
                    trackingAction={PROPERTY_BOOK_V2}
                    prices={priceHistory}
                  />}

                  <DashboardWidget
                    statuses={['DONE']}
                    placeHolder={() => <div />}
                    render={() => <NewStaticMapWidget isNewPageConcept />}
                    widthClasses="one-whole"
                  />

                  <DashboardWidget
                    statuses={[priceHistoryStatus]}
                    placeHolder={() => <div />}
                    render={() => <PriceInformation />}
                    widthClasses="one-whole"
                  />

                  <PriceTableWidget />

                  <DashboardWidget
                    statuses={['DONE']}
                    placeHolder={() => <div />}
                    render={() => (
                      <NewMyPropertyTeaser
                        onButtonClicked={() => window.location = PRICE_OVERVIEW_PROMO_NEW_TO_HOMEOWNER_LANDINGPAGE_URL }
                        trackingAction={PROPERTY_BOOK_V2}
                      />
                    )}
                    widthClasses={`one-whole ${styles.myPropertyContainer}`}
                  />
                  {shareOfVoiceWidgetGeoLevels.indexOf(hierarchyLevel) !== -1 &&
                    shareOfVoiceRealEstateTypes.indexOf(realEstateType) !== -1 &&
                    this.isTabVisible(TAB.home.id) && (
                    <DashboardWidget
                      statuses={[addressStatus, geoHierarchyStatus, priceHistoryStatus]}
                      render={() => <NewAtlasTouchpointWrapper campaignParams={CampaignParametersDashboard} />}
                      widthClasses="one-whole"
                    />
                  )}
                  <DashboardWidget
                    statuses={[priceHistoryStatus]}
                    widthClasses="one-whole"
                    render={() => (
                      <Faq apartmentPrices={apartmentPrices} housePrices={housePrices} onToggle={this.onWindowScroll} />
                    )}
                  />
                  <DashboardWidget
                    statuses={[subHierarchyLinkStatus]}
                    render={() => (
                      <NewSubHierarchyInfoWidget
                        onExpand={this.onWindowScroll}
                        hierarchyLevel={hierarchyLevel}
                        geoType={geoType}
                        subHierarchyLinks={subHierarchyLinks}
                      />
                    )}
                    widthClasses="one-whole"
                  />
                </div>
              </div>
              <div className={`grid-item grid-item-fixed-width lap-hide palm-hide ${styles.widgetColumn}`}>
                <div className={styles.widgetColumnContent}>
                  <div className={styles.stickyContainer} data-sticky={this.state.stickyWidget}>
                    <div className="grid grid-flex">
                      <DashboardWidget
                        statuses={[addressStatus]}
                        placeHolder={() => <div />}
                        render={() => <NewPriceCheckWidget type="bigScreen" />}
                        widthClasses="desk-one-whole lap-hide palm-hide"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <NewPriceCheckWidget type="smallScreen" visibility={this.state.stickyBottomWidget} />
      </>
    );
  }
}

NewDashboard.propTypes = {
  location: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  addressStatus: getAddressStatus(state),
  address: getAddress(state),
  geoHierarchyStatus: getGeoHierarchyStatus(state),
  geoHierarchy: getGeoHierarchy(state),
  priceHistory: getPricesForPriceHistoryWidget(state),
  priceHistoryStatus: getPriceHistoryStatus(state),
  realEstateType: getRealEstateType(state),
  hierarchyLevel: getHierarchyLevel(state),
  geoType: getGeoType(state),
  subHierarchyLinkStatus: getSubHierarchyLinksStatus(state),
  subHierarchyLinks: getSubHierarchyLinks(state),
  addressTitle: getAddressTitleAndSubtitle(state).title,
  apartmentAndHousePrices: getApartmentAndHousePrices(state),
  userIntent: getUserIntent(state),
  duplicateDistricts: getDuplicateDistricts(state),
  pageTitle: getPageViewId(state),
});

export default withLocation(withNavigate(connect(mapStateToProps)(NewDashboard)));
